/* =========================================================================
    About History Page
========================================================================= */

    function offset(el) {
        var rect = el.getBoundingClientRect(),
            scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return {top: rect.top + scrollTop, left: rect.left + scrollLeft}
    }

    function removeClassFromAllElement(className) {
        var elems = document.querySelectorAll(".year-period-list .period-year");
        [].forEach.call(elems, function (el) {
            el.classList.remove(className);
        });
    }

    function addClassToElement(className, year) {
        var elems = document.querySelectorAll(`.year-period-list .period-year.block_${year}`);
        [].forEach.call(elems, function (el) {
            el.classList.add(className);
        });
    }

    function scrollPeriodLabel() {

        yearBlockArray.forEach(function (block, index) {

            var scrollY = window.scrollY + window.innerHeight / 2;
            var periodLabels = document.getElementsByClassName("year-period-list");

            if (periodLabels && periodLabels.length) {
                periodLabels = periodLabels[0];
            } else {
                periodLabels = null;
            }

            if ((index + 1) === yearBlockArray.length) {

                if (scrollY >= block.offsetY && scrollY < (block.offsetY + block.element.offsetHeight - unitYearLabelHeight)) {

                    currPeriodLabelIndex = index;
                    if (periodLabels) {
                        periodLabels.style.position = "fixed";
                        setTimeout(function() {periodLabels.style.transition= "top .3s ease-in-out 0s";}, 300);
                        periodLabels.style.top = `calc(50vh - ${70 + currPeriodLabelIndex * unitYearLabelHeight}px)`;
                    }
                    removeClassFromAllElement("active");
                    addClassToElement("active", yearBlockArray[currPeriodLabelIndex].blockLabel);
                }
                if (scrollY >= (block.offsetY + block.element.offsetHeight - unitYearLabelHeight)) {
                    if (periodLabels) {
                        //console.log("END")
                        periodLabels.style.position = "absolute";
                        periodLabels.style.transition = "none";
                        //periodLabels.style.top = block.offsetY + block.element.offsetHeight - unitYearLabelHeight - periodLabels.offsetHeight + "px";
                        periodLabels.style.top = "unset";
                        periodLabels.style.bottom = "0px";

                    }
                }

            } else {

                if (scrollY >= block.offsetY && scrollY < yearBlockArray[index + 1].offsetY) {
                    currPeriodLabelIndex = index;
                    if (periodLabels) {
                        periodLabels.style.position = "fixed";
                        setTimeout(function () {periodLabels.style.transition= "top .3s ease-in-out 0s";}, 300);
                        periodLabels.style.top = `calc(50vh - ${70 + currPeriodLabelIndex * unitYearLabelHeight}px)`;
                    }
                    removeClassFromAllElement("active");
                    addClassToElement("active", yearBlockArray[currPeriodLabelIndex].blockLabel);
                }
                if (index === 0 && scrollY < block.offsetY + 100) {
                    if (periodLabels) {
                        //console.log("START")
                        periodLabels.style.position = "absolute";
                        // periodLabels.style.top = block.offsetY - unitYearLabelHeight + "px";
                        periodLabels.style.top =  "0px";
                        periodLabels.style.transition = "none";
                    }
                }
            }
        });
    }

    var unitYearLabelHeight = 0;
    var yearEles = document.querySelectorAll(".year-period-list .period-year");

    if (yearEles && yearEles.length) {
        var marginBottom = parseInt(window.getComputedStyle(yearEles[0]).marginBottom.replace("px", ""));
        unitYearLabelHeight = yearEles[0].offsetHeight + marginBottom;
    }

    var blockPeriods = [];
    blockPeriods = blockPeriods.concat(Array.from(document.querySelectorAll('.timeline__section .milestone')));

    var yearBlockArray = [];
    if (blockPeriods) {
        blockPeriods.forEach(function (block) {
            var blockLabel = block.id;
            // block.classList.forEach(function (className) {
            //     if (className === "block2") {
            //         blockLabel = "1960s"
            //     } else if (className === "block4") {
            //         blockLabel = "2021";
            //     } else if (className.includes("block_")) {
            //         blockLabel = className.replace("block_", "");
            //     }
            // });

            yearBlockArray.push({
                element: block,
                offsetY: offset(block).top,
                blockLabel: blockLabel,
            });
        });
    }

    var currPeriodLabelIndex = 0;
    scrollPeriodLabel();

    window.onscroll = function () {
        scrollPeriodLabel();
    };

    document.querySelectorAll('.year-period-list ul li').forEach(function(timeline){
        timeline.addEventListener("click", function(){
            const timelineId = timeline.id.split('-')[1];
            var elmntToView = document.getElementById(timelineId);
            // elmntToView.scrollIntoView();
            smoothScroll(elmntToView);
            document.getElementById(timeline.id).classList.add("active")
        })
    })

    window.smoothScroll = function(target) {
        var scrollContainer = target;
        do { //find scroll container
            scrollContainer = scrollContainer.parentNode;
            if (!scrollContainer) return;
            scrollContainer.scrollTop += 1;
        } while (scrollContainer.scrollTop == 0);
    
        var targetY = 0;
        do { //find the top of target relatively to the container
            if (target == scrollContainer) break;
            targetY += target.offsetTop;
        } while (target = target.offsetParent);
    
        scroll = function(c, a, b, i) {
            i++; if (i > 30) return;
            c.scrollTop = a + (b - a) / 30 * i;
            setTimeout(function(){ scroll(c, a, b, i); }, 10);
        }
        // start scrolling
        scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
    }